import graphql__cc87423a0a26d86bade4 from "./__generated__/AnswerPreviewAddress_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ShallowAnswerPreview from "./ShallowAnswerPreview";

const AnswerPreviewAddress = props => {
  return props.answer.answers.map(answer => (
    <div key={answer.id}>
      <ShallowAnswerPreview answer={answer} />
    </div>
  ));
};

export default createFragmentContainer(AnswerPreviewAddress, {
  answer: graphql__cc87423a0a26d86bade4
});
